import { Perimeter, Polygon, Project } from "@nova/protobuf"
import {
    colorValidators,
    createLayerValidator,
    genericUpdateLayerValidator,
    strokeValidators,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { isValidLonLat } from "@nova/calculate-geospatial"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"
const polygonValidators = [
    {
        validator: (polygons: Polygon[]) =>
            polygons.every(
                (polygon) =>
                    polygon.coordinates.length >= 3 &&
                    polygon.coordinates.every((coordinate) => isValidLonLat(coordinate))
            ),
        error: "Perimeter contains invalid polygons",
    },
]

const widthValidator = [
    {
        validator: (val: number) => val > 0,
        error: "Width must be greater than 0",
    },
]

export const createPerimeterValidator = createLayerValidator(Perimeter, {
    polygons: { validators: polygonValidators, nonNull: true },
    width: { validators: widthValidator },
    outline: { validators: colorValidators },
    stroke: { validators: strokeValidators },
    buffers: {
        validators: [
            {
                validator: (val) => val.range.every((buffer) => buffer.distance !== null),
                error: "Buffer distance buffer must be non-null",
            },
            {
                validator: (val) => val.range.every((buffer) => buffer.distance !== 0),
                error: "Buffer distance must be non-zero",
            },
            {
                validator: (val) =>
                    val.range.every((buffer) =>
                        colorValidators.every((validator) => validator.validator(buffer.color))
                    ),
                error: "Invalid color",
            },
        ],
    },
    parentId: genericUpdateLayerValidator.parentId,
    index: genericUpdateLayerValidator.index,
})

export const updatePerimeterValidator = updateLayerValidator(Perimeter, {
    polygons: { validators: polygonValidators, nonNull: true },
    width: { validators: widthValidator },
    outline: { validators: colorValidators },
    stroke: { validators: strokeValidators },
    buffers: {
        validators: [
            {
                validator: (val) => val.range.every((buffer) => buffer.distance !== null),
                error: "Buffer distance buffer must be non-null",
            },
            {
                validator: (val) => val.range.every((buffer) => buffer.distance !== 0),
                error: "Buffer distance must be non-zero",
            },
            {
                validator: (val) =>
                    val.range.every((buffer) =>
                        colorValidators.every((validator) => validator.validator(buffer.color))
                    ),
                error: "Invalid color",
            },
        ],
    },
})

export const getDefaultPerimeterCreateArgs = (project: Project, inParentId?: string) => ({
    visible: true,
    createdAt: dateAsNumber(),
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    // parentId would never got autopopulated
    parentId: undefined,
})

export type CreatePerimeterArgs = UnionToTuple<keyof typeof createPerimeterValidator>
export type UpdatePerimeterArgs = UnionToTuple<keyof typeof updatePerimeterValidator>
